import { createAction, props } from '@ngrx/store';
import { ProfileUnsignedUploadedDocument } from 'src/app/recruiting/candidates/new-profile/candidate-uploaded-profile-document/models/profile-unsigned-uploaded-document.model';

export const loadUnsignedDocuments = createAction(
    '[Unsigned Upload Document] Load Unsigned Upload Document',
    props<{ candidateId : number }>()
);

export const loadUnsignedDocumentsSuccess = createAction(
    '[Unsigned Upload Document] Load Unsigned Upload Document Success',
    props<{ documents: ProfileUnsignedUploadedDocument[], progress: number, hasUnsignedFlowEnabled: boolean, candidateId: number }>()
);

export const loadUnsignedDocumentsFail = createAction('[Unsigned Upload Document] Load Unsigned Upload Document Fail', props<{ error: any }>());

export const unloadUnsignedDocuments = createAction('[Unsigned Unload Document] Unload Unsigned Upload Document');

